import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CatalogSectionService } from './catalog-section.service';
import { SmartFilterItem } from './catalog-filter.service';
import { CompareService } from './compare/compare.service';
import { defaultOrder } from './catalog-items-default.component';
import { BitrixSortProps } from './lib/BitrixSortProperties';
import {CityService} from './city.service';

export const sortList: {
  name: string;
  value: BitrixSortProps;
}[] = [
  {
    name: 'Умолчанию',
    value: defaultOrder
  },
  {
    name: 'Цене по возрастанию',
    value: { catalog_PRICE_1: 'ASC' }
  },
  {
    name: 'Цене по убыванию',
    value: { catalog_PRICE_1: 'DESC' }
  }
];

@Component({
  selector: 'catalog-filter',
  templateUrl: './catalog/catalog-section-filter/catalog-filter.component.html',
  styleUrls: ['./catalog/catalog-section-filter/catalog-filter.component.less']
})
export class CatalogFilterComponent {
  filterProperties: SmartFilterItem[] = [];
  @Input() loadingState: boolean;
  @Output() orderChange = new EventEmitter<any>();
  sortOption: number = 0;
  filterPrice: [number, number] = [0, 0];

  sortList = sortList;

  constructor(
    public compareService: CompareService,
    public sectionService: CatalogSectionService,
    public cityService: CityService
  ) {}

  public changeOrder() {
    if (this.sortOption) {
      this.orderChange.emit(this.sortList[this.sortOption].value);
    }
  }

  public triggerChangePrice() {} // init to avoid errors in the common template

  public changeProp(value: any) {} // init to avoid errors in the common template

}
